/* eslint-disable no-prototype-builtins */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import SettingsIcon from "@material-ui/icons/Settings";
import lod_ from "lodash";
import React, { Fragment, useEffect, useState, useMemo } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { withTranslation } from "react-i18next";
import { connect, useDispatch, useSelector } from "react-redux";
import { bindActionCreators, compose } from "redux";
import userGroupActions from "../../redux/actions/userGroupActions.js";
import userStatusActions from "../../redux/actions/userStatusActions";
import "../../assets/css/language-selector.css";
import "../../assets/css/profil.css";
import i18n from "../../i18n";
import settings from "../../helpers/settingFunctions";
import EditProfile from "../Profile/EditProfil";
import { AvatarProfile } from "components/UserProfileComponent";

import SnackbarStore from "pages/Cockpit/SnackbarStore.js";
import { FormControlLabel, Icon, Radio, RadioGroup, Switch } from "@material-ui/core";
import { useTheme } from "../../theme";
import {
	SentimentSatisfied,
	Brightness4,
	Brightness7,
	SortRounded,
	CalendarTodayRounded,
	Language,
	SignalCellularConnectedNoInternet4Bar,
	AddToQueueOutlined,
	ListAltRounded,
	AccountCircleRounded,
	GroupWork,
	PermContactCalendar,
	SupervisedUserCircleRounded,
	FilterList,
	Inbox,
	Mail
} from "@material-ui/icons";

const useStyles = makeStyles(theme => ({
	container: {
		backgroundColor: theme.palette.background.paper,
		borderRadius: 4,
		border: `1px solid ${theme.palette.divider}`,
		boxShadow: theme.shadows[1]
	},
	profileCard: {
		display: "flex",
		flexDirection: "column",
		alignItems: "stretch",
		padding: theme.spacing(2.5),
		backgroundColor: theme.palette.background.default,
		borderRadius: 8,
		border: `1px solid ${theme.palette.divider}`,
		marginBottom: theme.spacing(3),
		gap: theme.spacing(2)
	},
	settingsCard: {
		backgroundColor: theme.palette.background.default,
		borderRadius: 8,
		border: `1px solid ${theme.palette.divider}`,
		padding: theme.spacing(2, 2.5),
		marginBottom: theme.spacing(2)
	},
	sectionTitle: {
		color: theme.palette.text.secondary,
		fontSize: 12,
		fontWeight: 700,
		textTransform: "uppercase",
		letterSpacing: "0.08em"
	},
	optionRow: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		padding: theme.spacing(1.25, 0),
		"&:not(:last-child)": {
			borderBottom: `1px solid ${theme.palette.divider}`
		}
	},

	colorCircle: {
		cursor: "pointer",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		position: "relative",
		transition: "transform 0.2s",
		"&:hover": {
			transform: "scale(1.1)"
		}
	}
}));

/**
 * Team color options with i18n keys and hex values
 * Structure: { key: translation_key, value: hex_color }
 */
const TEAM_COLORS_BASE = [
	{ key: "COLORS.NONE", value: null },
	{ key: "COLORS.BLUE", value: "#0078D4" },
	{ key: "COLORS.LIGHT_BLUE", value: "#B3D6F2" },
	{ key: "COLORS.LIGHT_PURPLE", value: "#D6C7E8" },
	{ key: "COLORS.LIGHT_PINK", value: "#F2B8C6" },
	{ key: "COLORS.PEACH", value: "#F2C6B8" },
	{ key: "COLORS.PALE_YELLOW", value: "#F2E0B8" },
	{ key: "COLORS.PALE_GREEN", value: "#C6E8B8" },
	{ key: "COLORS.DARK_BLUE", value: "#2E5A87" },
	{ key: "COLORS.DARK_PURPLE", value: "#5A2E87" },
	{ key: "COLORS.BURGUNDY", value: "#872E5A" },
	{ key: "COLORS.BROWN", value: "#875A2E" },
	{ key: "COLORS.DARK_GREEN", value: "#5A872E" }
];

/**
 * External notification options with i18n keys
 * Structure: { key: notification_key, label: translation_key }
 */
const ACTION_NOTIFICATION_OPTIONS = [
	{ key: "addConvNoteSkill", label: "EDIT_FORM.notifMentionSkill" },
	{ key: "addConvNoteProfile", label: "EDIT_FORM.notifMentionProfile" },
	{ key: "escalateConv", label: "EDIT_FORM.notifEscalade" },
	{ key: "escalateDoneConv", label: "EDIT_FORM.notifDescalade" },
	{ key: "assignConv", label: "EDIT_FORM.notifAssign" },
	{ key: "newConversation", label: "EDIT_FORM.notifCreateConv" }
];

/**
 * Conversation filter options with i18n keys and filter codes
 * Structure: { label: translation_key, value: filter_code }
 */
const CONVERSATION_FILTER_OPTIONS = [
	{ value: "asc", label: "EDIT_FORM.filterConversationOptions.asc", icon: SortRounded },
	{ value: "date", label: "EDIT_FORM.filterConversationOptions.date", icon: CalendarTodayRounded },
	{
		value: "channel",
		label: "EDIT_FORM.filterConversationOptions.channel",
		icon: Mail
	},
	{ value: "language", label: "EDIT_FORM.filterConversationOptions.language", icon: Language },
	{
		value: "priority",
		label: "EDIT_FORM.filterConversationOptions.priority",
		icon: SignalCellularConnectedNoInternet4Bar
	},
	{
		value: "sentiment",
		label: "EDIT_FORM.filterConversationOptions.sentiment",
		icon: SentimentSatisfied
	},
	{
		value: "subState",
		label: "EDIT_FORM.filterConversationOptions.subState",
		icon: AddToQueueOutlined
	},
	{ value: "intent", label: "EDIT_FORM.filterConversationOptions.intent", icon: ListAltRounded },
	{
		value: "agent",
		label: "EDIT_FORM.filterConversationOptions.agent",
		icon: AccountCircleRounded
	},
	{ value: "skills", label: "EDIT_FORM.filterConversationOptions.skills", icon: GroupWork },
	{
		value: "contactFilter",
		label: "EDIT_FORM.filterConversationOptions.contactFilter",
		icon: PermContactCalendar
	},
	{
		value: "convShowFilter",
		label: "EDIT_FORM.filterConversationOptions.convShowFilter",
		icon: SupervisedUserCircleRounded
	},
	{
		value: "actionFilter",
		label: "EDIT_FORM.filterConversationOptions.actionFilter",
		icon: FilterList
	},
	{ value: "direction", label: "EDIT_FORM.filterConversationOptions.direction", icon: Inbox }
];

function Profile(props) {
	const selectedAssistantID = useSelector(state => state.selectedAssistantID);
	const classes = useStyles();

	const { isDarkMode, toggleTheme } = useTheme();
	const [selectedUser, setSelectedUser] = useState({});
	const [editProfile, setEditProfile] = useState({ open: false });
	const [showAlert, setShowAlert] = useState({ open: false, success: true });
	const [languages, setLanguages] = useState(["FR", "EN"]);
	const [signatures, setSignatures] = useState([]);
	const [mySign, setMysign] = useState("");
	const [isAssistantSwitched, setIsAssistantSwitched] = useState(false);

	useEffect(() => {
		if (props.userStatus.auth && props.userStatus.auth.user) {
			setSelectedUser(props.userStatus.auth.user);
		}
	}, [props.userStatus.auth]);

	useEffect(() => {
		setIsAssistantSwitched(true);
	}, [selectedAssistantID]);

	/**
	 * Get signatures depends current assistant id
	 */

	useEffect(() => {
		if (
			props.userStatus.auth &&
			props.userStatus.auth.user &&
			props.userStatus.auth.user.signatures
		) {
			let signatures = props.userStatus.auth.user.signatures;

			let mySignature =
				signatures &&
				signatures.length > 0 &&
				signatures !== undefined &&
				signatures.filter(s => s.assistantID === selectedAssistantID).map(s => s);
			setSignatures(signatures);
			setMysign(mySignature[0]);
		} else {
			setSignatures("");
			setMysign("");
		}
	}, [props.userStatus.auth, selectedAssistantID, mySign]);

	/**
	 * Set user options values when user cockpit settings are updated
	 */
	useEffect(() => {
		setValueMessage(
			props?.userStatus?.auth?.user?.cockpitSettings?.cockpitTextVersion || "default"
		);
		setValueDisplay(props?.userStatus?.auth?.user?.cockpitSettings?.displayEditor || false);
		setValueOrder(
			props?.userStatus?.auth?.user?.cockpitSettings?.forceMessageSortNewerToOlder || false
		);
		setValueShowSignatureAndForward(
			props?.userStatus?.auth?.user?.cockpitSettings?.showSignatureAndForward || false
		);

		setValueShowConversationAfterResponse(
			props?.userStatus?.auth?.user?.cockpitSettings?.showConversationAfterResponse || false
		);

		setValueSubject(
			props?.userStatus?.auth?.user?.cockpitSettings?.defaultTopicOrSubject || "default"
		);
		setValueTabInfo(props?.userStatus?.auth?.user?.cockpitSettings?.openDefaultTabInfo || "close");

		setValueColor(props?.userStatus?.auth?.user?.cockpitSettings?.color || null);
		setValueDarkMode(props?.userStatus?.auth?.user?.cockpitSettings?.darkMode || false);
		setValueConversationFilters(
			props?.userStatus?.auth?.user?.cockpitSettings?.visibleConversationFilters ??
				CONVERSATION_FILTER_OPTIONS.map(f => f.value)
		);
		setValueExternalNotificationsActive(
			props?.userStatus?.auth?.user?.externalNotificationsActive || false
		);
		setValueExternalNotifications(
			props?.userStatus?.auth?.user?.cockpitSettings?.externalNotifications || {
				addConvNoteSkill: false,
				addConvNoteProfile: false,
				escalateConv: false,
				escalateDoneConv: false,
				assignConv: false,
				newConversation: false
			}
		);
	}, [props?.userStatus?.auth?.user?.cockpitSettings]);

	const handleCloseUserEditor = () => {
		setEditProfile({ open: false });
	};

	const hideAlert = () => {
		setShowAlert({ open: false, success: true });
	};

	const handleSaveProfile = userToUpdate => {
		setSelectedUser({ ...selectedUser, picture: "" });
		if (userToUpdate !== selectedUser.language) {
			const newLanguage = userToUpdate.language.toLowerCase();
			i18n.changeLanguage(newLanguage);
			localStorage.setItem("lang", newLanguage);
		}
		props.userStatusActions.saveUserdata(
			userToUpdate,
			() => {
				setShowAlert({ open: true, success: true });
			},
			() => {
				setShowAlert({ open: true, success: false });
			}
		);
		setEditProfile({ open: false });
	};

	const getRole = searchedRole => {
		const role = settings.getRoles().find(role => role.value === searchedRole);
		if (role) {
			return i18n.t(`EDIT_FORM.roles.${role.code}`);
		} else {
			return searchedRole;
		}
	};

	const [valueMessage, setValueMessage] = useState(
		props?.userStatus?.auth?.user?.cockpitSettings?.cockpitTextVersion || "default"
	);

	const [valueDisplay, setValueDisplay] = useState(
		props?.userStatus?.auth?.user?.cockpitSettings?.displayEditor || true
	);

	const [valueOrder, setValueOrder] = useState(
		props?.userStatus?.auth?.user?.cockpitSettings?.forceMessageSortNewerToOlder || false
	);

	// Show Signature And Forward
	const [valueShowSignatureAndForward, setValueShowSignatureAndForward] = useState(
		props?.userStatus?.auth?.user?.cockpitSettings?.showSignatureAndForward || false
	);

	// Show conversation after response
	const [valueShowConversationAfterResponse, setValueShowConversationAfterResponse] = useState(
		props?.userStatus?.auth?.user?.cockpitSettings?.showConversationAfterResponse || false
	);

	// Show conversation after response
	const [valueQuickGenerateAnswer, setValueQuickGenerateAnswer] = useState(
		props?.userStatus?.auth?.user?.cockpitSettings?.quickGenerateAnswer || false
	);

	// Color Profile Option state
	const [valueColor, setValueColor] = useState(
		props?.userStatus?.auth?.user?.cockpitSettings?.color || null
	);

	// Dark Mode preference state
	const [valueDarkMode, setValueDarkMode] = useState(
		props?.userStatus?.auth?.user?.cockpitSettings?.darkMode || false
	);

	// Conversation filters to show in cockpit state
	const [valueConversationFilters, setValueConversationFilters] = useState(
		props?.userStatus?.auth?.user?.cockpitSettings?.visibleConversationFilters ??
			CONVERSATION_FILTER_OPTIONS.map(f => f.value)
	);

	// External notifications state
	const [valueExternalNotificationsActive, setValueExternalNotificationsActive] = useState(
		props?.userStatus?.auth?.user?.externalNotificationsActive || false
	);
	const [valueExternalNotifications, setValueExternalNotifications] = useState(
		props?.userStatus?.auth?.user?.cockpitSettings?.externalNotifications || {
			addConvNoteSkill: false,
			addConvNoteProfile: false,
			escalateConv: false,
			escalateDoneConv: false,
			assignConv: false,
			newConversation: false
		}
	);

	/**
	 * Memoized team colors with translations
	 * Recreates only when i18n language changes
	 */
	const TEAM_COLORS = useMemo(() => {
		return TEAM_COLORS_BASE.map(color => ({
			name: i18n.t(color.key),
			value: color.value
		}));
	}, [i18n.language]);

	/**
	 * Memoized filter list to show with translations
	 * Recreates only when i18n language changes
	 */
	const FILTER_SHOW = useMemo(() => {
		return CONVERSATION_FILTER_OPTIONS.map(filter => ({
			name: i18n.t(filter.label),
			value: filter.value,
			icon: filter.icon
		}));
	}, [i18n.language]);

	const [valueSubject, setValueSubject] = useState(
		props?.userStatus?.auth?.user?.cockpitSettings?.defaultTopicOrSubject || "default"
	);

	const [valueTabInfo, setValueTabInfo] = useState(
		props?.userStatus?.auth?.user?.cockpitSettings?.openDefaultTabInfo || "close"
	);

	const dispatch = useDispatch();

	const handleChangeMessage = e => {
		changeOption("formatMessage", e.target.value);

		//dispatch(cockpitActions.changeFormatMessage(channelCode, initialDraft));
		setValueMessage(e.target.value);
	};

	const handleChangeDisplay = e => {
		changeOption("displayMessage", e.target.checked);
		setValueDisplay(e.target.checked);
	};

	const handleToggleDisplay = () => {
		const next = !valueDisplay;
		changeOption("displayMessage", next);
		setValueDisplay(next);
	};

	// Handle Order Message
	const handleChangeOrder = e => {
		const val = e.target.value === "true";
		changeOption("orderMessage", val);
		setValueOrder(val);
	};

	// Handle Show signature in reply
	const handleToggleShowSignatureAndForward = () => {
		const next = !valueShowSignatureAndForward;
		changeOption("showSignatureAndForward", next);
		setValueShowSignatureAndForward(next);
	};

	// Handle Show Conversation after response
	const handleChangeShowConversationAfterResponse = e => {
		changeOption("showConversationAfterResponse", e.target.checked);
		setValueShowConversationAfterResponse(e.target.checked);
	};

	// Handle quick generate answer
	const handleChangeQuickGenerateAnswer = e => {
		changeOption("quickGenerateAnswer", e.target.checked);
		setValueQuickGenerateAnswer(e.target.checked);
	};

	// Handle Show Signature And Forward Change
	const handleChangeShowSignatureAndForward = e => {
		changeOption("showSignatureAndForward", e.target.checked);
		setValueShowSignatureAndForward(e.target.checked);
	};

	// Toggle Show Conversation after response
	const handleToggleShowConversationAfterResponse = () => {
		const next = !valueShowConversationAfterResponse;
		changeOption("showConversationAfterResponse", next);
		setValueShowConversationAfterResponse(next);
	};

	// Toggle Quick Generate answer
	const handleToggleQuickGenerateAnswer = () => {
		const next = !valueQuickGenerateAnswer;
		changeOption("quickGenerateAnswer", next);
		setValueQuickGenerateAnswer(next);
	};

	// Handle Dark Mode Change
	const handleChangeDarkMode = e => {
		toggleTheme();
		changeOption("darkMode", e.target.checked);
		setValueDarkMode(e.target.checked);
	};

	// Handle Color Change
	const handleChangeColor = color => {
		changeOption("colorProfile", color);
		setValueColor(color);
	};

	const handleChangeSubject = e => {
		changeOption("subjectMessage", e.target.value);
		setValueSubject(e.target.value);
	};

	const handleChangeTabInfo = e => {
		changeOption("showTabInfo", e.target.value);
		setValueTabInfo(e.target.value);
	};

	// Toggle conversation filter in the list of conversation filters to show in cockpit
	const handleToggleConversationFilter = filterCode => {
		const nextValue = valueConversationFilters.includes(filterCode)
			? valueConversationFilters.filter(filter => filter !== filterCode)
			: [...valueConversationFilters, filterCode];

		changeOption("visibleConversationFilters", nextValue);
		setValueConversationFilters(nextValue);
	};

	const handleChangeExternalNotificationsActive = e => {
		changeOption("externalNotificationsActive", e.target.checked);
		setValueExternalNotificationsActive(e.target.checked);
	};

	const handleToggleExternalNotificationsActive = () => {
		const next = !valueExternalNotificationsActive;
		changeOption("externalNotificationsActive", next);
		setValueExternalNotificationsActive(next);
	};

	const handleChangeExternalNotification = key => e => {
		const next = { ...valueExternalNotifications, [key]: e.target.checked };
		changeOption("externalNotifications", next);
		setValueExternalNotifications(next);
	};

	const handleToggleExternalNotification = key => () => {
		const next = { ...valueExternalNotifications, [key]: !valueExternalNotifications[key] };
		changeOption("externalNotifications", next);
		setValueExternalNotifications(next);
	};

	const changeOption = (code, value) => {
		dispatch(userStatusActions.saveOptionUser({ code, action: code, value }));
	};

	return (
		<Fragment>
			<Box className={`customScrollBar ${classes.container}`} overflow="auto">
				<Box p={3} style={{ width: "80%", margin: "0 auto" }}>
					{selectedUser && (
						<>
							{/* Profile Header */}
							<Box className={classes.profileCard}>
								<Box display="flex" alignItems="center" style={{ gap: 8 }}>
									<AvatarProfile
										user={selectedUser}
										role={getRole(selectedUser.role)}
										classes={classes}
										color={valueColor}
									/>

									<Box
										display="flex"
										alignItems="center"
										style={{ gap: 8, marginLeft: "auto", cursor: "pointer" }}
										onClick={handleChangeDarkMode}
									>
										<Icon style={{ color: isDarkMode ? "white" : "gray" }}>
											{isDarkMode ? <Brightness4 /> : <Brightness7 />}
										</Icon>

										<Box
											disableTypography={true}
											primary={isDarkMode ? props.t("THEME.lightMode") : props.t("THEME.darkMode")}
											style={{ color: isDarkMode ? "white" : "" }}
										/>
										{isDarkMode ? props.t("THEME.darkMode") : props.t("THEME.lightMode")}
										<Switch color="primary" size="small" checked={valueDarkMode} />
									</Box>
								</Box>

								{/* Conversation Filters */}
								<Box>
									<Box className={classes.sectionTitle} mb={1}>
										{i18n.t("EDIT_FORM.titleOptionFiltreConversation")}
									</Box>
									<Box display="flex" flexWrap="wrap" style={{ gap: 8 }}>
										{FILTER_SHOW.map(option => {
											const active = valueConversationFilters.includes(option.value);
											const IconComp = option.icon;
											return (
												<Box
													key={option.value}
													onClick={() => handleToggleConversationFilter(option.value)}
													display="flex"
													alignItems="center"
													style={{
														gap: 6,
														padding: "5px 12px",
														borderRadius: 20,
														cursor: "pointer",
														fontSize: 13,
														fontWeight: active ? 600 : 400,
														border: active
															? "2px solid #1976d2"
															: `1px solid ${isDarkMode ? "var(--dark-border-color)" : "#DBDBDB"}`,
														backgroundColor: active
															? isDarkMode
																? "rgba(25,118,210,0.2)"
																: "rgba(25,118,210,0.08)"
															: isDarkMode
																? "var(--dark-bg-elevated)"
																: "#FAFAFA",
														color: active
															? "#1976d2"
															: isDarkMode
																? "var(--dark-text-secondary)"
																: "#555",
														transition: "all 0.15s ease",
														userSelect: "none"
													}}
												>
													{IconComp && (
														<IconComp style={{ fontSize: 15, opacity: active ? 1 : 0.55 }} />
													)}
													{option.name}
												</Box>
											);
										})}
									</Box>
								</Box>

								{/* Team Color */}
								<Box>
									<Box className={classes.sectionTitle} mb={1}>
										{i18n.t("EDIT_FORM.titleOptionColor")}
									</Box>
									<Box display="flex" flexWrap="wrap" style={{ gap: 8 }}>
										{TEAM_COLORS.map(color => (
											<Box
												key={String(color.value)}
												onClick={() => handleChangeColor(color.value)}
												title={color.name}
												style={{
													width: 32,
													height: 32,
													borderRadius: "50%",
													backgroundColor:
														color.value || (isDarkMode ? "var(--dark-bg-elevated)" : "#F0F0F0"),
													cursor: "pointer",
													border:
														valueColor === color.value
															? "3px solid #1976d2"
															: `1px solid ${isDarkMode ? "var(--dark-border-color)" : "#DBDBDB"}`,
													display: "flex",
													alignItems: "center",
													justifyContent: "center",
													position: "relative",
													transition: "transform 0.15s ease, border 0.15s ease",
													transform: valueColor === color.value ? "scale(1.1)" : "scale(1)"
												}}
											>
												{color.value === null && (
													<Box
														style={{
															position: "absolute",
															width: "70%",
															height: "2px",
															backgroundColor: isDarkMode ? "var(--dark-text-secondary)" : "#999",
															transform: "rotate(45deg)"
														}}
													/>
												)}
											</Box>
										))}
									</Box>
								</Box>
							</Box>

							{/* Settings title */}
							<Box display="flex" alignItems="center" mb={2}>
								<SettingsIcon style={{ fontSize: 16, opacity: 0.55 }} />
								<Box ml={1} className={classes.sectionTitle}>
									{i18n.t("EDIT_FORM.profilOption")}
								</Box>
							</Box>

							<Box display="flex" flexWrap="wrap" style={{ gap: 12 }}>
								{/* Multiple OPTIONS */}
								{/* Message Format */}
								<Box className={classes.settingsCard} style={{ flex: "1 1 150px" }}>
									<Box>{i18n.t("EDIT_FORM.titleOptionMessage")}</Box>
									<RadioGroup onChange={handleChangeMessage} value={valueMessage}>
										<FormControlLabel
											value="default"
											control={<Radio size="small" color="primary" />}
											label={i18n.t("EDIT_FORM.defaultOption")}
										/>
										<FormControlLabel
											value="clean"
											control={<Radio size="small" color="primary" />}
											label={i18n.t("EDIT_FORM.optionTextClean")}
										/>
										<FormControlLabel
											value="html"
											control={<Radio size="small" color="primary" />}
											label={i18n.t("EDIT_FORM.optionTextHtml")}
										/>
									</RadioGroup>
								</Box>

								{/* Subject */}
								<Box className={classes.settingsCard} style={{ flex: "1 1 150px" }}>
									<Box>{i18n.t("EDIT_FORM.titleOptionSubject")}</Box>
									<RadioGroup onChange={handleChangeSubject} value={valueSubject}>
										<FormControlLabel
											value="default"
											control={<Radio size="small" color="primary" />}
											label={i18n.t("EDIT_FORM.defaultOption")}
										/>
										<FormControlLabel
											value="subject"
											control={<Radio size="small" color="primary" />}
											label={i18n.t("EDIT_FORM.subjectOption")}
										/>
										<FormControlLabel
											value="topic"
											control={<Radio size="small" color="primary" />}
											label={i18n.t("EDIT_FORM.topicOption")}
										/>
									</RadioGroup>
								</Box>

								{/* Tab Info */}
								<Box className={classes.settingsCard} style={{ flex: "1 1 150px" }}>
									<Box>{i18n.t("EDIT_FORM.titleOptionTabInfo")}</Box>
									<RadioGroup onChange={handleChangeTabInfo} value={valueTabInfo}>
										<FormControlLabel
											value="close"
											control={<Radio size="small" color="primary" />}
											label={i18n.t("EDIT_FORM.tabCloseOption")}
										/>
										<FormControlLabel
											value="open"
											control={<Radio size="small" color="primary" />}
											label={i18n.t("EDIT_FORM.tabOpenOption")}
										/>
										<FormControlLabel
											value="openAll"
											control={<Radio size="small" color="primary" />}
											label={i18n.t("EDIT_FORM.tabOpenAllOption")}
										/>
									</RadioGroup>
								</Box>

								{/* Order Message */}
								<Box className={classes.settingsCard} style={{ flex: "1 1 150px" }}>
									<Box>{i18n.t("EDIT_FORM.titleOptionOrder")}</Box>
									<RadioGroup onChange={handleChangeOrder} value={valueOrder}>
										<FormControlLabel
											value={true}
											control={<Radio size="small" color="primary" />}
											label={i18n.t("EDIT_FORM.orderOption")}
										/>
										<FormControlLabel
											value={false}
											control={<Radio size="small" color="primary" />}
											label={i18n.t("EDIT_FORM.orderOptionDefault")}
										/>
									</RadioGroup>
								</Box>

								{/* Toggle Options */}
								<Box className={classes.settingsCard} style={{ flex: "0 0 100%" }}>
									{/* Pop-up response */}
									<Box
										className={classes.optionRow}
										style={{ cursor: "pointer" }}
										onClick={handleToggleDisplay}
									>
										<Box>{i18n.t("EDIT_FORM.titleOptionDisplay")}</Box>
										<Switch
											color="primary"
											size="small"
											checked={valueDisplay}
											onChange={handleChangeDisplay}
											onClick={e => e.stopPropagation()}
										/>
									</Box>

									{/* Show signature in reply */}
									<Box
										className={classes.optionRow}
										style={{ cursor: "pointer" }}
										onClick={handleToggleShowSignatureAndForward}
									>
										<Box>{i18n.t("EDIT_FORM.titleOptionShowSignatureAndForward")}</Box>
										<Switch
											color="primary"
											size="small"
											checked={valueShowSignatureAndForward}
											onChange={handleChangeShowSignatureAndForward}
											onClick={e => e.stopPropagation()}
										/>
									</Box>

									{/* Show conversation after response */}
									<Box
										className={classes.optionRow}
										style={{ cursor: "pointer" }}
										onClick={handleToggleShowConversationAfterResponse}
									>
										<Box>{i18n.t("EDIT_FORM.titleOptionCloseConversationAfterResponse")}</Box>
										<Switch
											color="primary"
											size="small"
											checked={valueShowConversationAfterResponse}
											onChange={handleChangeShowConversationAfterResponse}
											onClick={e => e.stopPropagation()}
										/>
									</Box>

									{/* Quick Generate answer */}
									<Box
										className={classes.optionRow}
										style={{ cursor: "pointer" }}
										onClick={handleToggleQuickGenerateAnswer}
									>
										<Box>{i18n.t("EDIT_FORM.titleOptionQuickGenerateAnswer")}</Box>
										<Switch
											color="primary"
											size="small"
											checked={valueQuickGenerateAnswer}
											onChange={handleChangeQuickGenerateAnswer}
											onClick={e => e.stopPropagation()}
										/>
									</Box>
								</Box>

								{/* Notification ext */}
								<Box className={classes.settingsCard} style={{ flex: "1 1 100%" }}>
									<Box
										className={classes.optionRow}
										style={{ cursor: "pointer" }}
										onClick={handleToggleExternalNotificationsActive}
									>
										<Box className={classes.optionLabel}>
											{i18n.t("EDIT_FORM.titleOptionExternalNotifications")}
										</Box>
										<Switch
											color="primary"
											size="small"
											checked={valueExternalNotificationsActive}
											onChange={handleChangeExternalNotificationsActive}
											onClick={e => e.stopPropagation()}
										/>
									</Box>
									{valueExternalNotificationsActive && (
										<Box mt={1} pl={2} style={{ borderLeft: "2px solid #666666" }}>
											{ACTION_NOTIFICATION_OPTIONS.map(({ key, label }) => (
												<Box
													key={key}
													className={classes.optionRow}
													style={{ cursor: "pointer" }}
													onClick={handleToggleExternalNotification(key)}
												>
													<Box className={classes.optionLabel} style={{ fontSize: 13 }}>
														{i18n.t(label)}
													</Box>
													<Switch
														color="primary"
														size="small"
														checked={valueExternalNotifications[key]}
														onChange={handleChangeExternalNotification(key)}
														onClick={e => e.stopPropagation()}
													/>
												</Box>
											))}
										</Box>
									)}
								</Box>
							</Box>
							{/* end flex row */}
						</>
					)}
				</Box>
			</Box>
			{editProfile.open && (
				<EditProfile
					open={editProfile.open}
					mode={editProfile.mode}
					handleCloseUserEditor={handleCloseUserEditor}
					handleSaveProfile={handleSaveProfile}
					langues={languages}
					userLanguage={selectedUser.language}
					userMobilePhone={selectedUser.mobilePhone}
					userDirectPhone={selectedUser.directPhone}
					user={selectedUser}
					signatures={signatures}
					mySign={mySign}
				/>
			)}
			<SweetAlert
				success={showAlert.success}
				error={!showAlert.success}
				title={showAlert.success ? i18n.t("alert.save") : i18n.t("alert.cannot")}
				timeout={2000}
				show={showAlert.open}
				onConfirm={hideAlert}
				onCancel={hideAlert}
				allowEscape={true}
				customButtons={
					<Button className="success" onClick={hideAlert}>
						{i18n.t("alert.confirm")}
					</Button>
				}
			/>
			<SnackbarStore />
		</Fragment>
	);
}

function mapStateToProps(state) {
	return state;
}
function mapDispatchToProps(dispatch) {
	return {
		userStatusActions: bindActionCreators(userStatusActions, dispatch),
		userGroupActions: bindActionCreators(userGroupActions, dispatch)
	};
}

export default compose(withTranslation(), connect(mapStateToProps, mapDispatchToProps))(Profile);
